import { isBase64String } from 'helpers/strings';
export function createCSVDownloadLink(text, fileName = 'export.csv') {
    let csvText;
    if (isBase64String(text)) {
        csvText = Buffer.from(text, 'base64').toString('utf-8');
    }
    else {
        csvText = text;
    }
    const blob = new Blob([csvText], { type: 'text/csv' });
    // create file link in browser's memory
    const href = URL.createObjectURL(blob);
    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}
